import {
  normalizeTotalPaginatedPayload,
  type TotalPaginatedPayload,
  type TotalPaginationPayload,
} from "@/lib/totalPagination";
import type { PaginatedResponse } from "@/types/api";

export interface ClinicalProductionPaginationPayload extends TotalPaginationPayload {}

export interface ClinicalProductionListPayload<T> extends TotalPaginatedPayload<T> {
  pagination: ClinicalProductionPaginationPayload;
}

export function normalizeClinicalProductionList<T>(payload: ClinicalProductionListPayload<T>): PaginatedResponse<T> {
  return normalizeTotalPaginatedPayload(payload, "Clinical production");
}
